import { useRequestAccountDeletion } from "@/Apollo/hooks/useRequestAccountDeletion";
import { useAuth } from "@/auth";
import { useExecAsync } from "@/common/hooks/general.hooks";
import { CommonModalActionCancel } from "@/components/common/modal/actions/CommonModalActionCancel";
import { CommonModal } from "@/components/common/modal/CommonModal";
import { CommonModalActionProps } from "@/components/common/modal/contracts/modal.contracts";
import { Button } from "@/ui/cva/Button";
import { closeModal, showModal } from "@/ui/Modal2";
import { useTranslation } from "next-i18next";

const AccountDeleteTitle = () => {
  const { t } = useTranslation();

  return <span>{t("account:account-settings-delete-account")}</span>;
};

const AccountDeleteModalContent = () => {
  const { t } = useTranslation();

  return (
    <span className="text-center">
      {t("account:account-settings-modal-delete-account")}
    </span>
  );
};

const AccountDeleteCancelAction = ({ modal }: CommonModalActionProps) => {
  const { t } = useTranslation();

  return (
    <CommonModalActionCancel
      key="cancel"
      modal={modal}
      color="attention"
      label={t("account:account-settings-modal-delete-account-cancel-button")}
    />
  );
};

const AccountDeleteModalDeleteAction = ({ modal }: CommonModalActionProps) => {
  const { t } = useTranslation();

  const { exec, isExecuting } = useExecAsync({
    onError: ex => console.error("AccountDeleteModalDeleteAction", ex),
  });

  const [requestDeletion] = useRequestAccountDeletion();
  const { logout } = useAuth();

  const handleClick = async () => {
    await exec(async () => {
      await requestDeletion();
      logout();
      closeModal(modal);
    });
  };

  return (
    <Button
      color="attention"
      size="large"
      loading={isExecuting}
      onClick={handleClick}
    >
      {t("account:account-settings-modal-delete-account-confirmation-button")}
    </Button>
  );
};

export const showAccountDeleteModal = () => {
  return showModal("common", {
    title: <AccountDeleteTitle />,
    content: <AccountDeleteModalContent />,
    actions: (modal: CommonModal) => [
      <AccountDeleteCancelAction key="cancel" modal={modal} />,
      <AccountDeleteModalDeleteAction key="delete" modal={modal} />,
    ],
  });
};
